import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LogoImage from '../images/logo';
import LogoWritten from '../images/skriftlig-logo';
import ProfileImage from '../icons/profile';
import CustomDropdown from '../dropdown';
import useRetrieveProfileInfo from '../../hooks/UserProfile';
import Loader from '../loader';
import CustomAlert from '../customAlert';

function Header() {

    const isLoggedIn = localStorage.getItem('vp-portal-token') !== null;

    const { profileInfo, isLoading, isError } = useRetrieveProfileInfo();

    const [isAdmin, setIsAdmin] = useState(false);

    const [isCustomer, setIsCustomer] = useState(false);

    const [isCustomAdmin, setIsCustomAdmin] = useState(false);

    useEffect(() => {
        if(profileInfo && profileInfo.role && profileInfo.role.type === 'admin') {
            setIsAdmin(true);
        }
        else if(profileInfo && profileInfo.role && profileInfo.role.type === 'kjede_admin') {
            setIsCustomAdmin(true);
        }
        else if(profileInfo && profileInfo.role && profileInfo.role.type === 'customer') {
            setIsCustomer(true);
        }
    }, [profileInfo]);

    const handleLogout = () => {
        const confirmLogout = window.confirm("Er du sikker på at du vil logge ut?");
    
        if (confirmLogout) {
          // Logikk for utlogging her
          // For eksempel: Fjern token fra localStorage og omdiriger til "/"
          localStorage.removeItem('vp-portal-token');
          localStorage.removeItem('vp-portal-user');
          alert("Du er nå logget ut!");
          window.location="/";
        }
      };

    if(isLoading || !profileInfo){
        return <Loader />
    }

    if(isError) {
        return <CustomAlert message="Oida, her gikk noe galt! Vennligst prøv igjen!"/>
    }

    return (
        <Navbar expand="md" className="">
            <Container className="d-flex justify-content-between mx-1 me-md-3 px-0 nav-container">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Brand className="col-5 col-md-3 m-auto d-flex flex-row justify-content-center align-items-center" as={NavLink} to="/" aria-label="Home">
                    <div className="">
                        <LogoImage />
                    </div>
                    <div className="col-8">
                        <LogoWritten />
                    </div>
                </Navbar.Brand> 
                <Navbar.Brand className="col-1 d-md-none">
                    <ProfileImage />
                </Navbar.Brand>
                <Navbar.Collapse className="justify-content-md-end" id="basic-navbar-nav">
                    <Nav className="col-8">
                        <Nav.Link as={NavLink} to="/home" className="nav-link" aria-label="Hjem">Hjem</Nav.Link>
                        <Nav.Link as={NavLink} to="/store" className="nav-link" aria-label="Nettbutikk">Nettbutikk</Nav.Link>
                        {isLoggedIn ? (
                            <> {isCustomAdmin && (
                                    <Nav.Link as={NavLink} to="/admin/home" className="nav-link" aria-label="Kjedeoversikt">Kjedeoversikt</Nav.Link>
                                )}
                                {isCustomer && (
                                    <Nav.Link as={NavLink} to="/profile" className="nav-link" aria-label="Profil">Profil</Nav.Link>
                                )}
                                {isAdmin && (
                                    <Nav.Link as={NavLink} to="/VP/admin/" className="nav-link" aria-label="VP-admin">Admin-panel</Nav.Link>
                                )}
                            {/* <Nav.Link as={NavLink} to="/profile" className="nav-link" aria-label="Profil">Profil</Nav.Link>
                            <Nav.Link as={NavLink} to="/admin/home" className="nav-link" aria-label="Kjedeoversikt">Kjedeoversikt</Nav.Link> */}
                            {/* <Nav.Link as={NavLink} to="/admin/home" className="nav-link" aria-label="Admin">Admin</Nav.Link> */}
                            <Nav.Link as={NavLink} to="/logout" className="nav-link" aria-label="Logg ut" onClick={handleLogout}>Logg ut</Nav.Link>
                            {/* <CustomDropdown /> */}
                            </>
                         ) : ( 
                            <Nav.Link as={NavLink} to="/login" className="nav-link" aria-label="Logg inn">Logg inn</Nav.Link>)}
                            <CustomDropdown />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Header;